module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_halloween_en-c7869daab17df5278a694be496e553fd.png";